<template>
  <Treeselect
    v-model="item"
    :options="treeOptions"
    :default-expand-level="0"
    :normalizer="normalizer"
    :clearable="clearable"
    :loading="loading"
    :showCount="true"
    :max-height="300"
    v-bind="$attrs"
    style="margin: 0 7px!important;"
  >
    <Treeselect-value :value="item" />
  </Treeselect>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect/src/components/Treeselect.vue'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { computed, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'GenresTreeSelectInput',
  components: { Treeselect },
  model: {
    prop: 'modelValue',
  },
  props: {
    modelValue: {
      type: [Number, Array],
      default: null,
    },
    treeOptions: { type: Array, default: () => [] },
    clearable: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const item = computed({
      get: () => props.modelValue,
      set: val => {
        emit('input', val)
      },
    })
    const loading = ref(false)

    const normalizer = node => {
      const normalizedNode = {
        id: node.id,
        label: node.label,
      }

      // Ajouter la clé 'children' uniquement si elle existe dans le nœud d'origine
      // et qu'elle n'est pas un tableau vide.
      if (node.children && node.children.length > 0) {
        normalizedNode.children = node.children
      }

      return normalizedNode
    }

    return { item, normalizer, loading }
  },
})
</script>
